import { Button, styled } from '@mui/material'

export const StyledButton = styled(Button)(({ theme }) => ({
  borderRadius: '5px'
}))
